import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './i18n'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import { BrowserRouter } from 'react-router-dom'
import { store } from 'src/app/store'
import App from 'src/app/App'
import { restoreSessionFromLocalStorage } from './app/shared/utils/sessionTransfer.util'

document.documentElement.dataset.build = 'release-261020'

restoreSessionFromLocalStorage()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistStore(store)}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
)
